<script lang="ts">
  import { utils } from '@borg/ui';

  export default {
    setup(props, context) {
      return () => {
        const vNodes = utils
          .flattenVNodes(context.slots.default?.() ?? [])
          .map((vNode) => h('li', { class: 'file-list__item' }, vNode));

        return h('ul', { class: 'file-list' }, vNodes);
      };
    },
  };
</script>

<style scoped lang="scss">
  .file-list {
    display: flex;
    flex-direction: column;
    margin: 0;

    &__item {
      border-bottom: 1px solid var(--mp-color-border-c-10);

      &:last-child {
        border-bottom: none;
      }
    }
  }
</style>
